import * as React from "react";
import { SVGProps } from "react";
export const ArrowUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.99999 16.667C9.76399 16.667 9.55899 16.58 9.38499 16.406C9.21166 16.2327 9.12499 16.028 9.12499 15.792V6.646L5.16699 10.604C4.98632 10.7847 4.78466 10.875 4.56199 10.875C4.33999 10.875 4.13866 10.7847 3.95799 10.604C3.77799 10.4233 3.68432 10.222 3.67699 10C3.67032 9.778 3.75732 9.57667 3.93799 9.396L9.37499 3.958C9.47232 3.86067 9.57299 3.79133 9.67699 3.75C9.78099 3.70867 9.88866 3.688 9.99999 3.688C10.1113 3.688 10.2223 3.70867 10.333 3.75C10.4443 3.79133 10.5417 3.86067 10.625 3.958L16.062 9.396C16.2427 9.57667 16.333 9.778 16.333 10C16.333 10.222 16.2427 10.4233 16.062 10.604C15.882 10.7847 15.6773 10.875 15.448 10.875C15.2187 10.875 15.0137 10.7847 14.833 10.604L10.875 6.667V15.792C10.875 16.028 10.7883 16.2327 10.615 16.406C10.441 16.58 10.236 16.667 9.99999 16.667Z"
            fill="currentColor"
        />
    </svg>
);
ArrowUpIcon.displayName = "ArrowUpIcon";
